// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container__slider {
    /* position: relative; */
    width: 100%;
    padding: 0;
    overflow: hidden;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    flex-wrap: nowrap;
    background-color: rgb(194, 180, 180);
    height: 100vh;
    /* height: max-content; */
  }
  
  .container__slider > button {
    background-color: transparent;
    outline: none;
    border: 0;
    color: whitesmoke;
    font-size: 24px;
  }
  
  .container__slider > button:active {
    color: black;
  }
  
  .slider__btn-next {
    position: absolute;
    right: 0;
  }
  
  .slider__btn-prev {
    position: absolute;
    left: 0;
  }
  
  .container__slider__links {
    position: fixed;
    bottom: 9%;
    left: 50%;
    transform: translateX(-50%);
  }
  
  .container__slider__links-small {
    position: relative;
    width: 9px;
    height: 9px;
    padding: 0;
    border-radius: 50%;
    outline: none;
    border: 0;
    background-color: white;
    border: 1px solid grey;
    transition: background-color 1s linear;
    margin: 0 8px;
  }
  
  .container__slider__links-small-active {
    background-color: black;
  }
  
  .slider__item {
    box-sizing: border-box;
    min-width: 100%;
    overflow: hidden;
    object-fit: cover;
    height: auto;
    transform: translateX(0);
    transition: transform 1s linear;
  }
  
  .slider__item-active-1 {
    transform: translateX(0);
  }
  
  .slider__item-active-2 {
    transform: translateX(-100%);
  }
  
  .slider__item-active-3 {
    transform: translateX(-200%);
  }
  
  .slider__item-active-4 {
    transform: translateX(-300%);
  }
  
  .slider__item-active-5 {
    transform: translateX(-300%);
  }
  
  .slider__item-active-6 {
    transform: translateX(-300%);
  }
  
  .slider__item-active-7 {
    transform: translateX(-300%);
  }
  
  .slider__item img {
    width: 100%;
    height: auto;
  }
  `, "",{"version":3,"sources":["webpack://./src/Components/Slider.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,oCAAoC;IACpC,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,OAAO;EACT;;EAEA;IACE,eAAe;IACf,UAAU;IACV,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,sBAAsB;IACtB,sCAAsC;IACtC,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,eAAe;IAEf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,wBAAwB;IACxB,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,YAAY;EACd","sourcesContent":[".container__slider {\n    /* position: relative; */\n    width: 100%;\n    padding: 0;\n    overflow: hidden;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    background-color: rgb(194, 180, 180);\n    height: 100vh;\n    /* height: max-content; */\n  }\n  \n  .container__slider > button {\n    background-color: transparent;\n    outline: none;\n    border: 0;\n    color: whitesmoke;\n    font-size: 24px;\n  }\n  \n  .container__slider > button:active {\n    color: black;\n  }\n  \n  .slider__btn-next {\n    position: absolute;\n    right: 0;\n  }\n  \n  .slider__btn-prev {\n    position: absolute;\n    left: 0;\n  }\n  \n  .container__slider__links {\n    position: fixed;\n    bottom: 9%;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  \n  .container__slider__links-small {\n    position: relative;\n    width: 9px;\n    height: 9px;\n    padding: 0;\n    border-radius: 50%;\n    outline: none;\n    border: 0;\n    background-color: white;\n    border: 1px solid grey;\n    transition: background-color 1s linear;\n    margin: 0 8px;\n  }\n  \n  .container__slider__links-small-active {\n    background-color: black;\n  }\n  \n  .slider__item {\n    box-sizing: border-box;\n    min-width: 100%;\n    height: auto;\n    overflow: hidden;\n    object-fit: cover;\n    height: auto;\n    transform: translateX(0);\n    transition: transform 1s linear;\n  }\n  \n  .slider__item-active-1 {\n    transform: translateX(0);\n  }\n  \n  .slider__item-active-2 {\n    transform: translateX(-100%);\n  }\n  \n  .slider__item-active-3 {\n    transform: translateX(-200%);\n  }\n  \n  .slider__item-active-4 {\n    transform: translateX(-300%);\n  }\n  \n  .slider__item-active-5 {\n    transform: translateX(-300%);\n  }\n  \n  .slider__item-active-6 {\n    transform: translateX(-300%);\n  }\n  \n  .slider__item-active-7 {\n    transform: translateX(-300%);\n  }\n  \n  .slider__item img {\n    width: 100%;\n    height: auto;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
